import React from 'react';
import { Container, Htag, HtagVariant, Paragraph } from '../../components';
import styles from './real-estate-expertise.module.css';

export default function RealEstateExpertise() {
  return (
    <section className={styles.expertise}>
      <Container>
        <Htag
          tag="h2"
          variant={HtagVariant.h2}
          className={styles.expertise_title}
        >
          OUR EXPERTISE
        </Htag>
        <Paragraph className={styles.expertise_text}>
          Over the past 4 years our MAVINX team delivered 10 digital solutions
          for Real Estate that assist agents in their sales process or allow
          clients to discover properties they are looking for.
        </Paragraph>
      </Container>
    </section>
  );
}
